import * as impl from './__HASH_IMPL__'

export type HashFunc = (s: string) => string

export const sha256 = (impl.sha256) as HashFunc

export const sha1 = (impl.sha1) as HashFunc

export const md5 = (impl.md5) as HashFunc
